import React from 'react';

import './project.modules.css';

const ProjectListHeader = () => {
    return (
        <div className='list-row header'>
            <div className='center id'>ID</div>
            <div className='center loalisation'>Локализация</div>
            <div className='flex-start name'>Наименование</div>
            <div className='flex-start description'>Описание</div>
            <div className='center requests'>Запросы</div>
            <div className='center actions'>Действия</div>
        </div>
    );
};

export default ProjectListHeader;